<template lang="pug">
  .filter-sheet
    y-bottom-sheet(v-model="showSheet" inset scrollable max-width="600px")
      v-card(flat)
        v-card-title.px-4
          div.h6.basic800--text {{ $t('filter_report') }}
          v-spacer
          v-btn(color="white" text @click="clearFilters")
            .button-Aa-small.primary400--text {{ $t('clear_filters') }}
          v-btn(color="textColorAccent" depressed height=32 dark @click="filterData")
            .button-AA-small.basic100--text {{ $t('filter') }}
        v-divider.basic300
        v-card-text.px-4.pb-8
          .date.mt-4
            div.d-flex
              .label.basic600--text.text-uppercase.mb-1 {{ $t('date_range') }}
              v-spacer
              p.mb-1.c1.basic600--text(v-if="range.id === 'custom' && selectedDateRange.length > 0")
                template(v-if="selectedDateRange.length > 1") {{ selectedDateRange[0] | humanizeDate }} ~ {{ selectedDateRange[1] | humanizeDate }}
                template(v-else) {{ selectedDateRange[0] | humanizeDate }}
            v-select.mt-2(item-color="basic100" v-model="range" :items="dateRangeSelections" item-text="text" item-value="value" background-color="basic200" height="40" outlined dense hide-details append-icon="mdi-chevron-down")
              template(v-slot:item="{ item }")
                v-list-item-content(v-if="item.value.id === 'custom'" @click="customDateRangePickerDialog = true")
                  v-list-item-title {{ item.text }}
                v-list-item-content(v-else)
                  v-list-item-title {{ item.text }}
          //.type.mt-4
            .label.basic600--text.text-uppercase.mb-1 report type
            v-select.mt-2(item-color="basic100" v-model="type" :items="typeSelections" item-text="text" item-value="value" background-color="basic200" height="40" outlined dense hide-details append-icon="mdi-chevron-down")

    .modals
      date-range-picker-dialog(:dialog.sync="customDateRangePickerDialog" @selected="dateRangeSelected($event)")

</template>

<script>
import DateRangePickerDialog from '../../views/admin/database/DateRangePickerDialog.vue'
export default {
  name: 'FilterDatabaseSheet',
  components: { DateRangePickerDialog},
  props: ['open', 'company', 'filtered', 'role'],
  data: () => ({
    type: { name: 'Accrual', id: 'accrual' },
    range: { name: 'This year to date', id: 'ytd' },
    selectedDateRange: [],
    typeSelections: [
      { text: 'Accrual', value: { name: 'Accrual', id: 'accrual' } },
      { text: 'Cash', value: { name: 'Cash', id: 'cash' } }
    ],
    dateRangeSelections: [
      { text: 'This month to date', value: { name: 'This month to date', id: 'mtd' } },
      { text: 'This quarter to date', value: { name: 'This quarter to date', id: 'qtd' } },
      { text: 'This year to date', value: { name: 'This year to date', id: 'ytd' } },
      { text: 'Last month', value: { name: 'Last month', id: 'last_month' } },
      { text: 'Last quarter', value: { name: 'Last quarter', id: 'last_quarter' } },
      { text: 'Last year', value: { name: 'Last year', id: 'last_year' } },
      { text: 'Custom', value: { name: 'Custom', id: 'custom' } }
    ],
    customDateRangePickerDialog: false,
  }),
  computed: {
    showSheet: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    if (this.filtered.status) {
      this.type = this.filtered.type
    } if (this.filtered.range) {
      this.range = this.filtered.range
    } if (this.filtered.selectedDateRange) {
      this.selectedDateRange = this.filtered.selectedDateRange
    }
  },
  methods: {
    filterData () {
      let data = {}
      if (this.type.id) {
        data.type = this.type
      }
      if (this.range.id) {
        data.range = this.range
        data.selectedDateRange = this.selectedDateRange
      }
      this.$emit('filtered', data)
      this.showSheet = false
    },
    clearFilters () {
      this.type = { name: 'Accrual', id: 'accrual' }
      this.range = { name: 'This year to date', id: 'ytd' }
      this.selectedDateRange = []
      this.filterData()
    },
    dateRangeSelected (dates) {
      this.selectedDateRange = dates
      this.range = { name: 'Custom' , id: 'custom' }
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white;
}
</style>

<i18n>
{
  "en": {
    "filter_report": "Filter report"
  },
  "id": {
    "filter_report": "Filter laporan"
  }
}
</i18n>